import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { authStorage } from '../../utils/authStorage'

interface AuthState {
  token: string | null
}

const initialState: AuthState = {
  token: authStorage.getToken() || null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
      authStorage.setToken(action.payload)
    },
    logout: (state) => {
      state.token = null
      authStorage.removeToken()
    }
  }
})

export const { setToken, logout } = authSlice.actions
export default authSlice.reducer
